<td class="text-nowrap small">{{ formatWhen(row.createdAt) }}</td>
<td>
    <div class="fw-semibold">{{ row.processName || row.processSlug }}</div>
</td>
<td>
    <span class="badge border fw-normal" [ngClass]="badgeClass(row)">
        {{ row.actionLabel }}
    </span>
</td>
<td>
    <div class="small">{{ actorLabel(row) }}</div>
    @if (row.userName && row.roleName) {
        <div class="text-muted small">{{ row.roleName }}</div>
    }
</td>
<td class="text-center text-nowrap small">{{ stepsLabel(row) }}</td>
<td class="text-center">
    @if (row.affectedCount > 0) {
        <span class="badge bg-warning-subtle text-dark">{{ row.affectedCount }}</span>
    } @else {
        <span class="text-muted">—</span>
    }
</td>
<td class="text-end text-nowrap">
    @if (row.canRollback) {
        <button type="button"
            class="btn btn-outline-warning btn-sm"
            title="Restaurar esta versión del flujo"
            [disabled]="anyBusy()"
            (click)="onRestore()">
            @if (isBusy()) {
                <i class="fas fa-spinner fa-spin me-1"></i>
            } @else {
                <i class="fas fa-undo me-1"></i>
            }
            Restaurar
        </button>
    } @else {
        <span class="text-muted small">—</span>
    }
</td>
